"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PathTemplate_1 = require("./PathTemplate");
var isFunction = require("lodash.isfunction");
var isString = require("lodash.isstring");
var notFoundHandler = function (req) {
    return Promise.reject({ code: "NOT_FOUND", request: req, message: "Unable to find handler for " + req.path });
};
var uselessRouter = {
    handleRequest: function (req, next) {
        return Promise.resolve(next ? next(req) : notFoundHandler(req));
    }
};
var RequestHandlerRouter = /** @class */ (function () {
    function RequestHandlerRouter(requestHandler) {
        this._requestHandler = requestHandler;
    }
    RequestHandlerRouter.prototype.handleRequest = function (req, next) {
        return Promise.resolve(this._requestHandler(req, next));
    };
    return RequestHandlerRouter;
}());
var createRouter = function (router) {
    if (isFunction(router)) {
        return new RequestHandlerRouter(router);
    }
    return router ? router : uselessRouter;
};
var PathRouter = /** @class */ (function () {
    function PathRouter(path, router) {
        this._pathTemplate = new PathTemplate_1.PathTemplate(path, { end: false });
        this._router = createRouter(router);
    }
    PathRouter.prototype.handleRequest = function (req, next) {
        var testPath = req.basePath ? req.path.substring(req.basePath.length) : req.path;
        var testResult = this._pathTemplate.test(testPath);
        if (testResult.match) {
            var handlerReq = Object.assign({}, req);
            handlerReq.params = Object.assign({}, req.params, testResult.params);
            var matchedPath = this._pathTemplate.toPath(handlerReq.params);
            handlerReq.basePath = req.basePath ? req.basePath + matchedPath : matchedPath;
            return this._router.handleRequest(handlerReq, next);
        }
        return Promise.resolve(next ? next(req) : notFoundHandler(req));
    };
    return PathRouter;
}());
var Router = /** @class */ (function () {
    function Router() {
    }
    Router.prototype.use = function (pathOrRouter, router) {
        var r;
        if (isString(pathOrRouter)) {
            r = new PathRouter(pathOrRouter, router);
        }
        else {
            r = createRouter(pathOrRouter);
        }
        var e = { r: r };
        if (!this._root) {
            this._root = e;
        }
        else {
            this._last.next = e;
        }
        this._last = e;
    };
    Router.prototype._processEntry = function (req, e, fallThrough) {
        var _this = this;
        if (e) {
            var next = function (nr) {
                return e.next ? _this._processEntry(nr || req, e.next, fallThrough) : fallThrough(req);
            };
            return e.r.handleRequest(req, next);
        }
        return fallThrough(req);
    };
    Router.prototype.handleRequest = function (req, next) {
        var _this = this;
        if (next === void 0) { next = notFoundHandler; }
        var fallThrough = function (req) {
            return _this.defaultHandler ? _this.defaultHandler(req, next) : next(req);
        };
        return this._processEntry(req, this._root, fallThrough);
    };
    return Router;
}());
exports.Router = Router;
